import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class OpenPanelService {
	private initialized = false;

	init(restaurantId: number, flowType: string): void {
		if (this.initialized || !restaurantId) return;
		this.initialized = true;

		const w = window as any;
		w.op = w.op || function (...args: any[]) { (w.op.q = w.op.q || []).push(args); };

		w.op('init', {
			apiUrl: environment.openPanel.apiUrl,
			clientId: environment.openPanel.clientId,
			trackScreenViews: true,
			trackOutgoingLinks: true,
			trackAttributes: true,
		});
		w.op('setGlobalProperties', { restaurant_id: String(restaurantId), flow_type: flowType });

		const script = document.createElement('script');
		script.src = 'assets/js/op1.js';
		script.async = true;
		script.defer = true;
		document.body.appendChild(script);
	}

	track(name: string, properties: { [key: string]: any } = {}): void {
		const w = window as any;
		// op1.js troca w.op por um Proxy cujo alvo é uma função (garante typeof === 'function').
		// Se revendorizar o SDK, confirmar que esse invariante continua valendo.
		if (!this.initialized || typeof w.op !== 'function') return;
		w.op('track', name, properties);
	}
}
